import { render, staticRenderFns } from "./SingleOrderSelection.vue?vue&type=template&id=c183fd98&"
import script from "./SingleOrderSelection.vue?vue&type=script&lang=js&"
export * from "./SingleOrderSelection.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrderSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vsts/work/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout,VTextField})
